let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("72Gwk"), load("3pwml")]).then(() => parcelRequire('jFrSc'));